export const globalConfig = {
  apiBaseURL: 'https://origohealthghana.gazelleplatform.com/services/',
  apiMainBaseURL: 'https://origohealthghana.gazelleplatform.com/services/security',
  apiDatahubBaseURL:
    'https://origohealthghana.gazelleplatform.com/services/security/api-proxy-service',
  apiDiagnosticBaseURL:
    'https://origohealthghana.gazelleplatform.com/services/diagnostics',
  apiServicesUrl: 'https://origohealthghana.gazelleplatform.com/services/api/',
  securityServicesUrl:
    'https://origohealthghana.gazelleplatform.com/services/security/',
  sharedServicesUrl:
    'https://origohealthghana.gazelleplatform.com/services/security/',
  apiPublicURL: 'https://api.gazelleplatform.com',
  loginUrl: 'https://app.origohealth.net',
  datahubHost: 'datahub.gazelleplatform.com',
  logoutUrl:
    'https://origotelehealth.auth0.com/v2/logout?client_id=OurBHJ5IJu1GZkPpc0tfp8CnjEIZfAnP&returnTo=https://www.origohealthghana.com',
  authUri:
    'https://origotelehealth.auth0.com/authorize?response_type=code&client_id=nSXQIFBzQGGUZlWTDeNK7gJ65MnNRlmb&redirect_uri=https://origohealthghana.gazelleplatform.com/callback&scope=openid%20profile%20email&state=S75G5ASAR9SSSS8DSFSSDS53S63S7D5FHS8G89G80YH9RTJUY5GSKGAS2L42UTF5Y36F93F7462U',
  targetUrl: 'https://origohealthghana.gazelleplatform.com/',
  userinfoUrl: 'https://origotelehealth.auth0.com/userinfo',
  neoUrl: "https://neo-origohealthghana.netlify.app",
  dynamoUrl: "https://dynamo-origohealthghana.netlify.app",
  breezeUrl: "https://breeze-origohealthghana.netlify.app",
  state:
    'S75G5ASAR9SSSS8DSFSSDS53S63S7D5FHS8G89G80YH9RTJUY5GSKGAS2L42UTF5Y36F93F7462U',
  platformWelcomeMessage: 'Welcome to the digital convergence experience',
  ehxClaimsTopicName: 'gazelle.ehx.claims.queue',
  ehxClaimsServer: 'amqp://192.168.192.6',
  bearerTokenValue:
    'B234A23N4S235A52SD35B34S6Z5K7L56FA87D69L79FK879A6S57F436K2JB42K34JS234FB2S3A423H4JF34B6K45A6S45F7B5K67A5S8J8D68F5H65S76A58F',
  userInfoUrl: 'https://origotelehealth.auth0.com/userinfo',
  developmentUrl: 'http://localhost:3011',
  paginationLimit: 5,
  googleMapsApi: 'AIzaSyCeNLUmMgY8Nw1aYy9jjyswHwrcK5p_dOg',
  auth0: {
    domain: 'origotelehealth.auth0.com',
    clientId: 'nSXQIFBzQGGUZlWTDeNK7gJ65MnNRlmb',
    managementAPIUrl: 'https://origotelehealth.auth0.com/api/v2/'
  },
  OPENTOK_URL: 'https://tokbox.com/embed/embed/ot-embed.js?',
  MAP_BOX_ACCESS_TOKEN:
    'pk.eyJ1Ijoib3JpZ29zb2Z0d2FyZSIsImEiOiJja2lkZXAyOTUwa2hpMnhwZXphcDEwYnBlIn0.bL_Xsmn35OU6bbpI9o84vQ',
  defaultFacilityId: 3597,
  defaultProviderId: 1,
  twilio: {
	messagingServiceSid : "MG6db97adf094eab87ba3d4656bd7c6259",
    contentSid : "HXfaa0bc60af3ba7136b108ff26c9fd1bb",
    whatsAppChannelNumber : "+18453799458",
	},
  serviceAccessToken: "linkedin|rz1MycKLaZ:520",
  cloudName: 'ORIGOHEALTH'
}
